import React, { useState } from "react";
import "./btnOrder.css";
import { Button, Space } from "antd";
import ModalForm from "../../modalForm/ModalForm";

export default function BtnOrder(props) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const onClickBtn = () => {
        setIsModalOpen(true);
    };
    return (
        <Space.Compact align="center" className="button__container">
            <div className="button__order">
                <Button
                    onClick={onClickBtn}
                    className="button"
                    size="large"
                    type="primary"
                    shape="round"
                >
                    {props.name}
                </Button>
                {isModalOpen && (
                    <ModalForm
                        isModalOpen={isModalOpen}
                        setIsModalOpen={setIsModalOpen}
                    />
                )}
            </div>
        </Space.Compact>
    );
}
